export const GB_FEATURES = {
  EXP_PUPPY_PAGE: 'exp_puppy_page',
  EXP_SEARCH_INFINITE_SCROLL_V2: 'exp_search_infinite_scroll_v2',
  EXP_SEARCH_INFINITE_SCROLL_V2_DESKTOP:
    'exp_search_infinite_scroll_v2_desktop',
  EXP_PROFILE_V_APP_3: 'exp_profile_v_app_3'
};
